export var PageId;
(function (PageId) {
    PageId["About"] = "about";
    PageId["MyAccount"] = "member_info";
    PageId["FollowingFollowers"] = "following_followers";
    PageId["MyRewards"] = "My Rewards";
    PageId["ForumPosts"] = "member-posts-page";
    PageId["ForumComments"] = "member-comments-page";
    PageId["Events"] = "events_members_page";
    PageId["BlogComments"] = "member-comments-page";
    PageId["BlogLikes"] = "member-likes-page";
    PageId["BlogPosts"] = "member-posts-page";
    PageId["BlogDrafts"] = "member-drafts-page";
    PageId["MyPosts"] = "My Posts";
    PageId["MyChallenges"] = "My Challenges";
    PageId["MyPrograms"] = "My Programs";
    PageId["MySubscriptions"] = "My Subscriptions";
    PageId["MyBookings"] = "bookings_member_area";
    PageId["Notifications"] = "notifications_app";
    PageId["MyAddresses"] = "my_addresses";
    PageId["MyOrders"] = "order_history";
    PageId["MyWallet"] = "my_wallet";
    PageId["Settings"] = "settings";
    PageId["SharedGallery"] = "Gallery";
    PageId["FileShare"] = "wix_file_share_members_page";
    PageId["MyWishlist"] = "wishlist";
    PageId["ContributorProfile"] = "contributor-profile";
    PageId["TestPublic"] = "test-vertical-public-widget";
    PageId["TestPrivate"] = "test-vertical-private-widget";
})(PageId || (PageId = {}));
//# sourceMappingURL=page.js.map